import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { TEXT_COLOR } from "../../theme";
import { useAuth0, User } from "@auth0/auth0-react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import { Tooltip } from "@material-ui/core";
import InstagramIcon from "@mui/icons-material/Instagram";
import CloudIcon from "@mui/icons-material/Cloud";
import { GetUserResponse } from "../../proto/api_pb";
import { styles } from "./styles";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const MoreBio: React.FC<User> = ({ user }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button onClick={handleClickOpen} sx={styles.readMoreButton}>
        ... read more
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <Box sx={styles.dialogBox}>
            <Typography variant="h4">Bio</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: TEXT_COLOR }}> {user.getBio()}</Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export const PersonalLinks: React.FC<{
  currentUser: GetUserResponse | undefined;
}> = ({ currentUser }) => {
  const { isAuthenticated } = useAuth0();

  const openLink = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <>
      {isAuthenticated && currentUser && (
        <Box sx={styles.socialMediaBox}>
          <Tooltip title="Website">
            <span>
              <IconButton
                disabled={currentUser?.getWebsiteLink() === ""}
                onClick={() => openLink(currentUser.getWebsiteLink())}
              >
                <LanguageRoundedIcon />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title="Instagram">
            <span>
              <IconButton
                disabled={currentUser?.getInstagramLink() === ""}
                onClick={() => openLink(currentUser.getInstagramLink())}
              >
                <InstagramIcon />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title="Spotify">
            <span>
              <IconButton
                disabled={currentUser?.getSpotifyLink() === ""}
                onClick={() => openLink(currentUser.getSpotifyLink())}
              >
                <img
                  style={{
                    width: "25px",
                    height: "25px",
                    filter:
                      currentUser?.getSpotifyLink() === ""
                        ? "grayscale(50%)"
                        : "none",
                    opacity: currentUser?.getSpotifyLink() === "" ? 0.5 : 1,
                  }}
                  src="/assets/icons/spotify.png"
                  alt=""
                />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title="SoundCloud">
            <span>
              <IconButton
                disabled={currentUser?.getSoundCloudLink() === ""}
                onClick={() => openLink(currentUser.getSoundCloudLink())}
              >
                <CloudIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )}
    </>
  );
};
